var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('syarat-ketentuan-desktop'):_c('syarat-ketentuan-mobile',{staticClass:"skMobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }